import { useMutation } from '@apollo/react-hooks';
import {
  ADD_BEHAVIOR_ITEM_BANK_CONTENT,
  ADD_COGNITIVE_ITEM_BANK_CONTENT,
} from '../services/item-bank-management.service';
import { BEHAVIOR_SECTION, COGNITIVE_SECTION } from '../constants';
import {
  getBehaviorDimensionInput,
  getBehaviorItemsInput,
  getCognitiveDimensionInput,
  getCognitiveItemsInput,
  getReportTextsInput,
} from '../helpers/item-bank-management.helper';
import { growlActionSuccess, growlErrors } from '../../../utils/NotificationUtil';
import { useContext } from 'react';
import { AccountContext } from '../../../components/AccountContext';
import { NotificationContext } from '../../../components/GrowlNotifications';

const useItembank = () => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const [addBehaviorItemBankContentMutation] = useMutation(ADD_BEHAVIOR_ITEM_BANK_CONTENT);
  const [addCognitiveItemBankContentMutation] = useMutation(ADD_COGNITIVE_ITEM_BANK_CONTENT);

  const handleSubmittingForm = (values) => {
    const { section } = values;

    if (section === BEHAVIOR_SECTION) {
      addBehaviorItemBankContent(values);
    }

    if (section === COGNITIVE_SECTION) {
      addCognitiveItemBankContent(values);
    }
  };

  const addBehaviorItemBankContent = async (values) => {
    const dimensionInput = getBehaviorDimensionInput(values);
    const itemsInput = getBehaviorItemsInput(values);
    const reportTextsInput = getReportTextsInput(values);

    try {
      await addBehaviorItemBankContentMutation({
        variables: {
          input: {
            accountId: currentAccount,
            dimensionInput,
            itemsInput,
            reportTextsInput,
          },
        },
      });
      growlActionSuccess(growl);
    } catch (mutationError) {
      growlErrors(growl, mutationError);
    }
  };

  const addCognitiveItemBankContent = async (values) => {
    const dimensionInput = getCognitiveDimensionInput(values);
    const itemsInput = getCognitiveItemsInput(values);
    const reportTextsInput = getReportTextsInput(values);

    try {
      await addCognitiveItemBankContentMutation({
        variables: {
          input: {
            accountId: currentAccount,
            dimensionInput,
            itemsInput,
            reportTextsInput,
          },
        },
      });
      growlActionSuccess(growl);
    } catch (mutationError) {
      growlErrors(growl, mutationError);
    }
  };

  return {
    handleSubmittingForm,
  };
};

export default useItembank;
